import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useToast } from '@w7/ui'
import { consumeToastFlash } from './toaster'

/** Renders nothing — drains sessionStorage flash toasts after OIDC redirects. */
export function ToastFlash() {
  const toast = useToast()
  const location = useLocation()
  const pushRef = useRef(toast.push)
  pushRef.current = toast.push

  useEffect(() => {
    const flash = consumeToastFlash()
    if (flash) pushRef.current(flash)
  }, [location.key])

  return null
}
